<template>
  <div class="loginLog">
    <commonTable
      ref="commonTable"
      url="/admin/login_info/list"
      reqMethod="GET"
      :column="column"
      :extraParams="extraParams"
      :searchColumn="searchColumn"
      limitKey="per_page"
      @isLoading="(val) => listLoading = val"
      @reset="() => {
        extraParams = {
          game_id: null,
          channel_id: null,
          game_channel_package_id: null,
        }
        channel_list = []
      }"
    >
      <template slot="search-back">

        <el-form-item label="游戏:">
        <el-select
          v-model="extraParams.game_id"
          clearable
          filterable
          placeholder="请选择"
          @change="clearGame"
          @clear="clearGame">
          <el-option
            v-for="item in gamesList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道:">
        <el-select
          v-model="channel_list"
          filterable
          clearable
          multiple
          collapse-tags
          placeholder="请选择"
          @change="(val) => extraParams.channel_id = val.toString()"
        >
          <el-option
            v-for="item in channelSelectList.filter(i => !extraParams.game_id || i.game_id === extraParams.game_id)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道包:">
        <el-select
          v-model="extraParams.game_channel_package_id"
          filterable
          clearable
          placeholder="请选择">
          <el-option
            v-for="item in channelPackagesList.filter(i => !extraParams.game_id || i.game_id === extraParams.game_id)"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      </template>
      <template slot="search" slot-scope="scope">
        <el-button
          type="success"
          plain
          icon="el-icon-download"
          @click="exportData({
            url: '/admin/login_info/list',
            name: '登陆日志',
            column,
            limit: 'per_page',
            method: 'GET',},
            {
              totalRecords: scope.totalRecords,
              searchValue: {
                ...scope.searchValue,
                ...extraParams,
              },
            })"
          class="mb1"
          :loading="listLoading">导出</el-button>
      </template>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import commonTable from '@/component/commonTable.vue'
import { exportData } from "@/assets/js/exportData"

export default {
  name: 'loginLog',
  data () {
    return {
      isEdit: '',
      dialogVisible: false,
      roleList: [],
      channelList: [],
      gamesList: [],
      form: {
        name: '',
        role_id: '',
        channel_ids: [],
        game_ids: [],
        username: '',
        password: ''
      },
      listLoading: false,
      exportData,
      extraParams: {
        game_id: null,
        channel_id: null,
        game_channel_package_id: null,
      },
      gamesList: [],
      channelSelectList: [],
      channelPackagesList: [],
      channel_list: [],
    }
  },
  computed: {
    column () {
      return [
        {
          label: "登陆时间",
          prop: "created_at"
        },
        {
          label: "用户ID",
          prop: "user_id"
        },
        {
          label: "用户名",
          prop: "user.username"
        },
        {
          label: "登陆IP",
          prop: "ip"
        },
        {
          label: "登陆GDID",
          prop: "gdid"
        },
        {
          label: "渠道包ID",
          prop: "channel_package.id",
        },
        {
          label: "渠道包名",
          prop: "channel_package.name",
        },
      ]
    }, 
    searchColumn () {
      return [
        {
          label: "用户名",
          prop: "username",
          type: "input",
        },
        {
          label: "IP",
          prop: "ip",
          type: "input",
        },
        {
          label: "GDID设备ID",
          prop: "gdid",
          type: "input",
        },
        {
          label: "登陆起始时间+登陆结束时间",
          prop: "created_from+created_to",
          type: "date",
          setDefault: true,
          timerange: []
        },
      ]
    }
  },
  methods: {
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data
      })
    },
    clearGame () {
      this.extraParams.channel_id = null
      this.extraParams.game_channel_package_id = null
      this.channel_list = []
    },
    // 获取渠道选择列表数据
    getchannelSelectList() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.channelSelectList = res.data.data
        }
      });
    },
    // 渠道包 下拉选择列表
    channelPackagesSelect() {
      fetch({
        url: "/admin/game_channel_packages/channel_package_select",
        method: "GET",
      }).then((res) => {
        this.channelPackagesList = res.data.data
      })
    },
  },
  mounted () {
    this.getGameSelectList()
    this.getchannelSelectList()
    this.channelPackagesSelect()
  },
  components: {
    commonTable
  }
}
</script>

<style lang="less" scoped>

</style>
